"use client";

import { ArrowRight } from "lucide-react";
import { useBookingResume } from "~/hooks/use-booking-resume";
import { Avatar, AvatarImage } from "~/components/ui/avatar";
import { HomepageTrackedLink } from "./homepage-tracked-link";

export function HomepageBookingLink({ className }: { className: string }) {
  const { resumeUrl, cartItem } = useBookingResume();
  return (
    <HomepageTrackedLink
      href={resumeUrl ?? "/slobodni-termini"}
      event="homepage_cta_clicked"
      eventProperties={{
        placement: "final",
        destination: resumeUrl ? "booking_resume" : "availability",
      }}
      className={className}
    >
      {resumeUrl && cartItem?.therapistImage && (
        <Avatar className="mr-2 h-6 w-6" aria-hidden="true">
          <AvatarImage src={cartItem.therapistImage} alt="" />
        </Avatar>
      )}
      {resumeUrl ? "Nastavi zakazivanje" : "Zakaži prvi razgovor"}
      <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
    </HomepageTrackedLink>
  );
}
